const analysesActionTypes = {
    SET_SELECTED_PROJECT_ITEM: 'SET_SELECTED_PROJECT_ITEM',
    SET_ANALYSES_LIST_DATA: 'SET_ANALYSES_LIST_DATA',
    SET_NEW_PROJECT_ID: 'SET_NEW_PROJECT_ID',
    SET_ANALYSIS_TRIGGER_MENU: 'SET_ANALYSIS_TRIGGER_MENU',
    SET_ANALYSIS_DATA_INFO: 'SET_ANALYSIS_DATA_INFO'
};

export default analysesActionTypes;